export default ({
  brandName,
  abbrNameForTealium,
}: {
  brandName: string;
  abbrNameForTealium: string;
}): string => {
  return brandName === 'gapfs' ? abbrNameForTealium : brandName;
};
